import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { JWT, SimpleLogin } from "../Constant";
import { Image } from "../AbstractElements";
import jwtImg from "../assets/images/jwt.svg";
import simpleLogin from '../assets/images/simple-login.svg';


const NavAuth = ({ callbackNav, selected }) => {
  return (
    <Nav className="border-tab flex-md-column" tabs>
      <NavItem>

      </NavItem>
      <NavItem>

      </NavItem>
    </Nav>
  );
};

export default NavAuth;
